module.exports = __webpack_public_path__ + "static/Orion-dc44fdfbe3ce3af2c030cc0096f94b41.jpg";